import createSlots from '../utils/create-slots';
var _createSlots = createSlots(['Caption', 'Label', 'LeadingVisual', 'Validation']),
  Slots = _createSlots.Slots,
  Slot = _createSlots.Slot;
export { Slots, Slot };